"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _videoChannel = require("@/api/videoChannel");
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _default = exports.default = {
  name: 'brandList',
  data: function data() {
    return {
      listLoading: false,
      tableData: {
        // 列表数据对象
        data: [],
        total: 0
      },
      tableFrom: {
        // 列表参数
        page: 1,
        limit: 20,
        brandWording: null // 类目名称
      },
      submitBrandAudit: {
        title: '自定义交易组件 - 品牌申请',
        visible: false,
        pramData: {
          auditReq: {
            license: null,
            brandInfo: {
              brandAuditType: null,
              // 认证审核类型 RegisterType，字符类型，最长不超过20
              trademarkType: null,
              // 商标分类 TrademarkType，字符类型，最长不超过10
              brandManagementType: null,
              // 选择品牌经营类型 BrandManagementType，字符类型，最长不超过10
              commodityOriginType: null,
              // 商品产地是否进口不能为空
              brandWording: null,
              // 商标/品牌词不能为空
              saleAuthorizationArr: [],
              // String list 销售授权书（如商持人为自然人，还需提供有其签名的身份证正反面扫描件)，图片url/media_id，图片类型，最多不超过10张
              saleAuthorization: null,
              trademarkRegistrationCertificateArr: [],
              // String list 商标注册证书，图片url/media_id，图片类型，最多不超过1张
              trademarkRegistrationCertificate: null,
              trademarkChangeCertificateArr: [],
              // String list 商标变更证明，图片url/media_id，图片类型，最多不超过5张
              trademarkChangeCertificate: null,
              trademarkRegistrant: null,
              // 商标注册人姓名，字符类型，最长不超过100
              trademarkRegistrantNu: null,
              // 商标注册号/申请号，最长不超过10
              trademarkAuthorizationPeriod: null,
              // 商标有效期，yyyy-MM-dd HH:mm:ss，字符类型，最长不超过30
              trademarkRegistrationApplicationArr: [],
              // 商标注册申请受理通知书，图片url/media_id，图片类型，最多不超过1张
              trademarkRegistrationApplication: null,
              trademarkApplicant: null,
              // 商标申请人姓名，字符类型，最长不超过100
              trademarkApplicationTime: null,
              // 商标申请时间，yyyy-MM-dd HH:mm:ss，字符类型，最长不超过30
              importedGoodsFormArr: [],
              // 中华人民共和国海关进口货物报关单，图片url/media_id，图片类型，最多不超过5张
              importedGoodsForm: null
            }
          }
        }
      },
      brandSubmitFromRules: {
        'pramData.auditReq.brandInfo.trademarkType': [{
          required: true,
          message: '请选择 商标分类',
          trigger: 'blur'
        }],
        'pramData.auditReq.license': [{
          required: true,
          message: '营业执照或组织机构代码证 不能为空',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.handleSearch();
  },
  methods: {
    handleSearch: function handleSearch() {
      this.tableFrom.page = 1;
      this.tableFrom.limit = 20;
      this.getList(this.tableFrom);
    },
    // 提交品牌审核
    handleSubmitBrandAudit: function handleSubmitBrandAudit(formName) {
      var _this2 = this;
      this.$refs[formName].validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
          var _pram;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!valid) {
                  _context.n = 7;
                  break;
                }
                _context.n = 1;
                return _this2.getShopImgUpload([_this2.submitBrandAudit.pramData.auditReq.license], []);
              case 1:
                _this2.submitBrandAudit.pramData.auditReq.license = _context.v.join(',');
                _context.n = 2;
                return _this2.getShopImgUpload(_this2.submitBrandAudit.pramData.auditReq.brandInfo.saleAuthorizationArr, []);
              case 2:
                _this2.submitBrandAudit.pramData.auditReq.brandInfo.saleAuthorization = _context.v;
                _context.n = 3;
                return _this2.getShopImgUpload(_this2.submitBrandAudit.pramData.auditReq.brandInfo.trademarkRegistrationCertificateArr, []);
              case 3:
                _this2.submitBrandAudit.pramData.auditReq.brandInfo.trademarkRegistrationCertificate = _context.v;
                _context.n = 4;
                return _this2.getShopImgUpload(_this2.submitBrandAudit.pramData.auditReq.brandInfo.trademarkChangeCertificateArr, []);
              case 4:
                _this2.submitBrandAudit.pramData.auditReq.brandInfo.trademarkChangeCertificate = _context.v;
                _context.n = 5;
                return _this2.getShopImgUpload(_this2.submitBrandAudit.pramData.auditReq.brandInfo.trademarkRegistrationApplicationArr, []);
              case 5:
                _this2.submitBrandAudit.pramData.auditReq.brandInfo.trademarkRegistrationApplication = _context.v;
                _context.n = 6;
                return _this2.getShopImgUpload(_this2.submitBrandAudit.pramData.auditReq.brandInfo.importedGoodsFormArr, []);
              case 6:
                _this2.submitBrandAudit.pramData.auditReq.brandInfo.importedGoodsForm = _context.v;
                _pram = JSON.parse(JSON.stringify(_this2.submitBrandAudit.pramData));
                delete _pram.auditReq.brandInfo.importedGoodsFormArr;
                delete _pram.auditReq.brandInfo.saleAuthorizationArr;
                delete _pram.auditReq.brandInfo.trademarkChangeCertificateArr;
                delete _pram.auditReq.brandInfo.trademarkRegistrationApplicationArr;
                delete _pram.auditReq.brandInfo.trademarkRegistrationCertificateArr;
                (0, _videoChannel.submitBrandAuditApi)(_pram).then(function (res) {
                  _this2.getList(_this2.tableFrom);
                }).finally(function () {
                  _this2.submitBrandAudit.visible = false;
                });
                _context.n = 8;
                break;
              case 7:
                return _context.a(2, false);
              case 8:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    getCatAndBrandResult: function getCatAndBrandResult(auditId) {
      var _this3 = this;
      (0, _videoChannel.brandCatAuditResultApi)({
        audit_id: auditId
      }).then(function (res) {
        _this3.getList(_this3.tableFrom);
      }).catch(function (err) {
        _this3.$message.error('手动同步审核结果失败:' + err);
      }).finally(function () {
        _this3.$message.info('手动同步审核结果完成');
      });
    },
    getList: function getList(pram) {
      var _this4 = this;
      this.listLoading = true;
      (0, _videoChannel.brandListApi)(pram).then(function (res) {
        _this4.tableData.data = res.list;
        _this4.tableData.total = res.total;
        _this4.listLoading = false;
      }).catch(function (err) {}).finally(function () {
        _this4.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList(this.tableFrom);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList(this.tableFrom);
    },
    // 点击商品图
    modalPicTap: function modalPicTap(multiple, num) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (!img) return;
        if (num === '1') {
          // 设置第一个值 营业执照或组织机构证件
          _this.submitBrandAudit.pramData.auditReq.license = img[0].sattDir;
        }
        if (num === '2') {
          // String list 销售授权书（如商持人为自然人，还需提供有其签名的身份证正反面扫描件)，图片url/media_id，图片类型，最多不超过10张
          img.map(function (item) {
            _this.submitBrandAudit.pramData.auditReq.brandInfo.saleAuthorizationArr.push(item.sattDir);
          });
        }
        if (num === '3') {
          // String list 商标注册证书，图片url/media_id，图片类型，最多不超过1张
          img.map(function (item) {
            _this.submitBrandAudit.pramData.auditReq.brandInfo.trademarkRegistrationCertificateArr.push(item.sattDir);
          });
        }
        if (num === '4') {
          // String list 商标变更证明，图片url/media_id，图片类型，最多不超过5张
          img.map(function (item) {
            _this.submitBrandAudit.pramData.auditReq.brandInfo.trademarkChangeCertificateArr.push(item.sattDir);
          });
        }
        if (num === '5') {
          // 商标注册申请受理通知书，图片url/media_id，图片类型，最多不超过1张
          img.map(function (item) {
            _this.submitBrandAudit.pramData.auditReq.brandInfo.trademarkRegistrationApplicationArr.push(item.sattDir);
          });
        }
        if (num === '6') {
          // 中华人民共和国海关进口货物报关单，图片url/media_id，图片类型，最多不超过5张
          img.map(function (item) {
            _this.submitBrandAudit.pramData.auditReq.brandInfo.importedGoodsFormArr.push(item.sattDir);
          });
        }
      }, multiple, 'payComponent');
    },
    getShopImgUpload: function () {
      var _getShopImgUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(attrs, arr) {
        var key, res, _t, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _t = _regeneratorKeys(attrs);
            case 1:
              if ((_t2 = _t()).done) {
                _context2.n = 3;
                break;
              }
              key = _t2.value;
              _context2.n = 2;
              return this.getImgData(attrs[key]);
            case 2:
              res = _context2.v;
              arr.push(res);
              _context2.n = 1;
              break;
            case 3:
              return _context2.a(2, arr);
          }
        }, _callee2, this);
      }));
      function getShopImgUpload(_x2, _x3) {
        return _getShopImgUpload.apply(this, arguments);
      }
      return getShopImgUpload;
    }(),
    // 转换当前素材为视频号素材链接
    getImgData: function getImgData(imgUrl) {
      return new Promise(function (resolve, reject) {
        (0, _videoChannel.shopImgUploadApi)({
          imgUrl: imgUrl,
          respType: 1,
          uploadType: 1
        }).then(function (res) {
          resolve(res.img_info.temp_img_url);
        });
      });
    }
  }
};